import { Component, h, Prop, Watch } from '@stencil/core';
import { ActionTrackingEvent } from '@union-investment/tracking/src/events';
import { getLocale } from '@union-investment/global-resources/src/utilities/language';
import { Link } from '../ui-cms-link/ui-cms-link';
import { getMediaFocalPoint } from '../../global/utility/utils';

export interface UiCmsTeaserArticleBody {
  headline: string;
  text: string;
  date?: string;
  category?: string;
  author?: string;
  image: string;
  links: Link[];
  imageAltText: string;
  imageRatio?: string;
  teaserStyle: 'text-light' | 'text-dark';
  imageFocalPoint?:
    | 'top-left'
    | 'top-center'
    | 'top-right'
    | 'center-left'
    | 'center-center'
    | 'center-right'
    | 'bottom-left'
    | 'bottom-center'
    | 'bottom-right';
}

@Component({
  tag: 'ui-cms-teaser-article',
  styleUrl: 'ui-cms-teaser-article.css',
})
export class UiCmsTeaserArticle {
  @Prop({ mutable: true }) body: UiCmsTeaserArticleBody;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Prop() ratio: '16/9' | '10/9' | '5/6' = '16/9';

  @Watch('utilityBody')
  utilityBodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  componentWillLoad() {
    this.utilityBodyChangeHandler(this.utilityBody);
  }

  onLinkClick() {
    const link = this.body.links[0];
    const trackingEvent: ActionTrackingEvent = {
      eventInfo: {
        eventName: 'Click Teaser Article',
        eventType: 'Action',
      },
      attributes: {
        elementType: 'Artikelteaser',
        elementLabel: this.body.headline,
        target: link.contentId,
      },
      category: {
        area: 'Content',
      },
    };

    if (trackingEvent) {
      window.ui?.services?.tracking?.track(trackingEvent);
    }
  }

  render() {
    const link = this.body.links[0]?.src;
    return (
      <ui-teaser-article
        headline={this.body.headline}
        text={this.body.text}
        date={
          this.body.date
            ? new Date(this.body.date).toLocaleDateString(getLocale(), {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
              })
            : undefined
        }
        author={this.body.author}
        category={this.body.category}
        teaserStyle={this.body.teaserStyle}
        href={link}
        target={this.body.links[0]?.target}
        image={this.body.image}
        imageAltText={this.body.imageAltText}
        imageRatio={this.body.imageRatio}
        imageFocalPointX={getMediaFocalPoint(this.body?.imageFocalPoint)?.focalPointX}
        imageFocalPointY={getMediaFocalPoint(this.body?.imageFocalPoint)?.focalPointY}
        replace="%RENDITION%"
        ratio={this.ratio}
        onClick={() => link && link !== '' && this.onLinkClick()}
      ></ui-teaser-article>
    );
  }
}
